import React, { useEffect, useState, Fragment, useRef } from 'react';
import { PageHeader } from '../../../../Common';
import { TableContentForRouteMangerPrintOption } from '../../../Common/Table/tableContent';
import services from '../services';
import InputLabel from '@material-ui/core/InputLabel';
import $ from 'jquery';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import Joi from '@hapi/joi';
import { LoadingSpinerComponent } from '../../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../Common/services';
import tokenService from '../../../../Common/tokenDecoder';
import ReactToPrint from "react-to-print";
import { CSVLink, CSVDownload } from "react-csv";
import TextField from '@material-ui/core/TextField';
import { FactoryWeightDetailsReportObject } from '../factoryWeightDetailsReportSchema';
import { validateProperty, validate } from "../../../Common";
import CreatePdf from './createPdf';
import _ from 'lodash';
import '../../../Common/Table/table.css';
import xlsx from 'json-as-xlsx';
import '../Pages/tableFooter.css';

const screenCode = 'FACTORYWEIGHTDETAILSREPORT';

export function FactoryWeightDetailsReportListing(props) {

    const componentRef = useRef();

    const [groups, setGroups] = useState();
    const [factories, setFactories] = useState();
    const [routes, setRoutes] = useState();
    const [errors, setErrors] = useState({})
    const [totalRow, setTotalRow] = useState({})

    const schema = Joi.object(FactoryWeightDetailsReportObject).options({ allowUnknown: true })
    const pdfRef = useRef(null);

    const [tableData, setTableData] = useState([]);
    const [searchForm, setSearchForm] = useState(
        {
            groupID: "0",
            routeID: "0",
            factoryID: "0",
            searchdate: ""
        }
    );

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "",
        route: "",
        factory: "",
        date: ""
    })

    const csvHeaders = [
        { label: "Route", value: "routeID" },
        { label: "Bag Count", value: "bagCount" },
        { label: "Actual Weight", value: "actualAmount" },
        { label: "Water", value: "water" },
        { label: "Bag", value: "bag" },
        { label: "Box", value: "box" },
        { label: "Boiled Leaf", value: "boiledLeaf" },
        { label: "Coarse Leaf", value: "coarseLeaf" },
        { label: "Other", value: "other" },
        { label: "Actual Net", value: "actualNet" },
        { label: "Net Weight", value: "netWeight" },
        { label: "Gain/Loss", value: "gainLoss" }
    ];

    const [isTableHide, setIsTableHide] = useState(true);
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });
    const initialContentRowNames = ["routeID", "bagCount", "actualAmount", "water", "bag", "box", "boiledLeaf", "coarseLeaf","other",  "actualNet", "netWeight", "gainLoss"];

    useEffect(() => {
        getPermissions();
    }, []);

    useEffect(() => {
        trackPromise(
            getEsatesForDropDown()
        )
    }, [searchForm.groupID])

    useEffect(() => {
        trackPromise(
            GetAllRoutesForDropDown()
        )
    }, [searchForm.factoryID])

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWFACTORYWEIGHTDETAILSREPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }

        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,

            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined,
        });

        var token = tokenService.getUserDetailsFromToken();
        setSearchForm({
            ...searchForm,
            groupID: token.groupID,
            factoryID: token.operationEntityID
        });

        setGroupDropDownData();
    }

    async function setGroupDropDownData() {
        const result = await services.getGroups()
        setGroups(result)
    }

    async function getEsatesForDropDown() {
        const factoryList = await services.getFactoryByGroupID(searchForm.groupID);
        setFactories(factoryList);
    }

    async function GetAllRoutesForDropDown() {
        const routeList = await services.GetAllRoutesByFactoryID(searchForm.factoryID);
        setRoutes(routeList);
    }

    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items;
    }

    function handleChange(e) {
        const target = e.target
        const value = target.name === 'active' ? target.checked : target.value

        const error = { ...errors }
        const errorMessage = validateProperty(target, FactoryWeightDetailsReportObject)
        errorMessage ? error[target.name] = errorMessage : delete error[target.name]

        setSearchForm({
            ...searchForm,
            [e.target.name]: value
        });
        setErrors(error);
        clearTableRelatedData();
    }

    async function handleSearch(e) {
        e.preventDefault();
        destroyDataTable();
        setIsTableHide(true);

        setSearchDataForPdf();

        const errorMessages = validate(schema, searchForm)
        errorMessages !== null ? setErrors(errorMessages) : setErrors({})
        if (errorMessages) return;

        var reportData = await services.getReportData(searchForm);
        let result = [];
        if (Array.isArray(reportData) && reportData.length > 0 && reportData[0].hasOwnProperty('routeID')) {
            result = reportData;

            const total = {
                bagCount: 0,
                water: 0,
                bag: 0,
                box: 0,
                boiledLeaf: 0,
                coarseLeaf: 0,
                other: 0,
                netWeight: 0,
                actualAmount: 0,
                deductionWeight: 0,
                gainLoss: 0
            };

            result.forEach(item => {
                total.bagCount += Number(item.bagCount || 0);
                total.water += Number(item.water || 0);
                total.bag += Number(item.bag || 0);
                total.box += Number(item.box || 0);
                total.boiledLeaf += Number(item.boiledLeaf || 0);
                total.coarseLeaf += Number(item.coarseLeaf || 0);
                total.other += Number(item.other || 0);
                total.netWeight += Number(item.netWeight || 0);
                total.actualAmount += Number(item.actualAmount || 0);
                total.deductionWeight += Number(item.deductionWeight || 0);

            });

            const actualNetTotal = total.actualAmount - total.deductionWeight;
            total.gainLoss = (actualNetTotal - total.netWeight);

            result.forEach(item => {
                item.routeID = (routes && routes[item.routeID] !== undefined) ? routes[item.routeID] : item.routeID;
                item.bagCount = (item.bagCount === undefined ? 0 : Number(item.bagCount));
                item.water = (item.water === undefined ? (0).toFixed(2) : Number(item.water).toFixed(2));
                item.bag = (item.bag === undefined ? (0).toFixed(2) : Number(item.bag).toFixed(2));
                item.box = (item.box === undefined ? (0).toFixed(2) : Number(item.box).toFixed(2));
                item.boiledLeaf = (item.boiledLeaf === undefined ? (0).toFixed(2) : Number(item.boiledLeaf).toFixed(2));
                item.coarseLeaf = (item.coarseLeaf === undefined ? (0).toFixed(2) : Number(item.coarseLeaf).toFixed(2));
                item.other = (item.other === undefined ? (0).toFixed(2) : Number(item.other).toFixed(2));
                item.actualAmount = (item.actualAmount === undefined ? (0).toFixed(2) : Number(item.actualAmount).toFixed(2));
                item.deductionWeight = (item.deductionWeight === undefined ? (0).toFixed(2) : Number(item.deductionWeight).toFixed(2));
                item.netWeight = (item.netWeight === undefined ? (0).toFixed(2) : Number(item.netWeight).toFixed(2));
                const itemDeductionWeight = Number(item.deductionWeight || 0);
                item.actualNet = (Number(item.actualAmount || 0) - itemDeductionWeight).toFixed(2);
                item.gainLoss = (item.actualNet - item.netWeight).toFixed(2);
            });

            setTotalRow({
                bagCount: total.bagCount,
                actualAmount: total.actualAmount,
                water: total.water,
                bag: total.bag,
                box: total.box,
                boiledLeaf: total.boiledLeaf,
                coarseLeaf: total.coarseLeaf,
                other: total.other,
                deductionWeight: total.deductionWeight,
                actualNet: actualNetTotal,
                netWeight: total.netWeight,
                gainLoss: total.gainLoss
            });

        }
        if (result.length > 0) {
            setIsTableHide(false);
            setTableData(result);
            createDataTable();
        }
    }

    function createFile() {
        var settings = {
            sheetName: 'Factory Weight Details Report',
            fileName: 'FactoryWeightDetailsReport',
            writeOptions: {}
        }
        var copyOfData = _.cloneDeep(tableData)
        copyOfData.forEach(x => {
        })

        if (totalRow && Object.keys(totalRow).length > 0) {
            const totalsForExport = {
                routeID: 'Total',
                bagCount: totalRow.bagCount !== undefined ? totalRow.bagCount : 0,
                actualAmount: totalRow.actualAmount !== undefined ? Number(totalRow.actualAmount).toFixed(2) : (0).toFixed(2),
                water: totalRow.water !== undefined ? Number(totalRow.water).toFixed(2) : (0).toFixed(2),
                bag: totalRow.bag !== undefined ? Number(totalRow.bag).toFixed(2) : (0).toFixed(2),
                box: totalRow.box !== undefined ? Number(totalRow.box).toFixed(2) : (0).toFixed(2),
                boiledLeaf: totalRow.boiledLeaf !== undefined ? Number(totalRow.boiledLeaf).toFixed(2) : (0).toFixed(2),
                coarseLeaf: totalRow.coarseLeaf !== undefined ? Number(totalRow.coarseLeaf).toFixed(2) : (0).toFixed(2),
                other: totalRow.other !== undefined ? Number(totalRow.other).toFixed(2) : (0).toFixed(2),
                actualNet: totalRow.actualNet !== undefined ? Number(totalRow.actualNet).toFixed(2) : (0).toFixed(2),
                netWeight: totalRow.netWeight !== undefined ? Number(totalRow.netWeight).toFixed(2) : (0).toFixed(2),
                gainLoss: totalRow.gainLoss !== undefined ? Number(totalRow.gainLoss).toFixed(2) : (0).toFixed(2)
            }
            copyOfData.push(totalsForExport)
        }

        xlsx(csvHeaders, copyOfData, settings, true)
    }

    function setSearchDataForPdf() {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchForm.groupID],
            route: routes[searchForm.routeID],
            factory: factories[searchForm.factoryID],
            date: searchForm.searchdate
        })
    }

    function destroyDataTable() {
        $('#reportTable').DataTable().destroy();
    }

    function createDataTable() {
        $('#reportTable').DataTable();
    }

    function onCancelClick() {
        setSearchForm({
            ...searchForm,
            routeID: "0",
            searchdate: ""
        });
        setErrors("");
        clearTableRelatedData();
    }

    function clearTableRelatedData() {
        setIsTableHide(true);
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12 card">
                    <div ref={pdfRef}>
                        <PageHeader
                            title="Factory Weigh Detail Report"
                        />
                        <div className="card-body">
                            <form onSubmit={(e) => trackPromise(handleSearch(e))}>
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="groupID"
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            name="groupID"
                                            value={searchForm.groupID}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="factoryID">Factory *</InputLabel>
                                        <Select fullWidth
                                            id="factoryID"
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            name="factoryID"
                                            value={searchForm.factoryID}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select factory--</MenuItem>
                                            {generateDropDownMenu(factories)}
                                        </Select>
                                        {errors["factoryID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["factoryID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="routeID">Route </InputLabel>
                                        <Select fullWidth
                                            id="routeID"
                                            name="routeID"
                                            value={searchForm.routeID}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select route--</MenuItem>
                                            {generateDropDownMenu(routes)}
                                        </Select>
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="searchdate">Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="searchdate"
                                            name="searchdate"
                                            type="date"
                                            onChange={(e) => handleChange(e)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </div>
                                </div>

                                <input
                                    type="submit"
                                    disabled={validate(schema, searchForm)}
                                    className="btn btn-primary"
                                    value="Generate"
                                />
                                <input type="reset"
                                    className="btn btn-warning pull-right"
                                    value="Clear"
                                    onClick={onCancelClick}
                                />

                                {isTableHide ? null :
                                    <div>
                                        <div className="table-responsive row-top-gap">
                                            <table
                                                id="reportTable"
                                                className="display dataTable no-footer">
                                                <thead>
                                                    <tr>
                                                        <th style={{ textAlign: "left" }} rowSpan="2">Route</th>
                                                        <th style={{ textAlign: "right" }} rowSpan="2">Bag Count</th>
                                                        <th style={{ textAlign: "right" }} rowSpan="2">Actual Weight</th>
                                                        <th style={{ textAlign: "center" }} colSpan="6">Deductions</th>
                                                        <th style={{ textAlign: "right" }} rowSpan="2">Actual Net</th>
                                                        <th style={{ textAlign: "right" }} rowSpan="2">Net Weight</th>
                                                        <th style={{ textAlign: "right" }} rowSpan="2">Gain/Loss</th>
                                                    </tr>
                                                    <tr>
                                                        <th style={{ textAlign: "right" }}>Water</th>
                                                        <th style={{ textAlign: "right" }}>Bag</th>
                                                        <th style={{ textAlign: "right" }}>Box</th>
                                                        <th style={{ textAlign: "right" }}>Boiled Leaf</th>
                                                        <th style={{ textAlign: "right" }}>Coarse Leaf</th>
                                                        <th style={{ textAlign: "right" }}>Other</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <TableContentForRouteMangerPrintOption
                                                        data={tableData}
                                                        contentRowNames={initialContentRowNames}
                                                        hasEdit={false}
                                                    />
                                                </tbody>
                                                <tfoot>
                                                    <tr>
                                                        <th>Total</th>
                                                        <th style={{ textAlign: "right" }}>{(totalRow && totalRow.bagCount !== undefined) ? Number(totalRow.bagCount).toFixed(0) : "0"}</th>
                                                        <th style={{ textAlign: "right" }}>{(totalRow && totalRow.actualAmount !== undefined) ? Number(totalRow.actualAmount).toFixed(2) : (0).toFixed(2)}</th>
                                                        <th style={{ textAlign: "right" }}>{(totalRow && totalRow.water !== undefined) ? Number(totalRow.water).toFixed(2) : (0).toFixed(2)}</th>
                                                        <th style={{ textAlign: "right" }}>{(totalRow && totalRow.bag !== undefined) ? Number(totalRow.bag).toFixed(2) : (0).toFixed(2)}</th>
                                                        <th style={{ textAlign: "right" }}>{(totalRow && totalRow.box !== undefined) ? Number(totalRow.box).toFixed(2) : (0).toFixed(2)}</th>
                                                        <th style={{ textAlign: "right" }}>{(totalRow && totalRow.boiledLeaf !== undefined) ? Number(totalRow.boiledLeaf).toFixed(2) : (0).toFixed(2)}</th>
                                                        <th style={{ textAlign: "right" }}>{(totalRow && totalRow.coarseLeaf !== undefined) ? Number(totalRow.coarseLeaf).toFixed(2) : (0).toFixed(2)}</th>
                                                        <th style={{ textAlign: "right" }}>{(totalRow && totalRow.other !== undefined) ? Number(totalRow.other).toFixed(2) : (0).toFixed(2)}</th>
                                                        <th style={{ textAlign: "right" }}>{(totalRow && totalRow.actualNet !== undefined) ? Number(totalRow.actualNet).toFixed(2) : (0).toFixed(2)}</th>
                                                        <th style={{ textAlign: "right" }}>{(totalRow && totalRow.netWeight !== undefined) ? Number(totalRow.netWeight).toFixed(2) : (0).toFixed(2)}</th>
                                                        <th style={{ textAlign: "right" }}>{(totalRow && totalRow.gainLoss !== undefined) ? Number(totalRow.gainLoss).toFixed(2) : (0).toFixed(2)}</th>
                                                    </tr>
                                                </tfoot>
                                            </table>
                                        </div>
                                        <div className="pt-2">
                                            <ReactToPrint
                                                documentTitle={"Factory Weight Details Report"}
                                                trigger={() => <input
                                                    type="button"
                                                    className="btn btn-primary pull-right ml-2"
                                                    value="Create PDF"
                                                />}
                                                content={() => componentRef.current}
                                            />
                                            <div hidden={true}>
                                                <CreatePdf ref={componentRef} data={tableData} total={totalRow}
                                                    rowNames={initialContentRowNames} searchData={selectedSearchValues} />
                                            </div>
                                            <input
                                                type="button"
                                                className="btn btn-primary pull-right ml-2"
                                                value="Excel"
                                                onClick={createFile}
                                            />
                                        </div>
                                    </div>
                                }
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}